import { FiatPrice } from "@b2bportal/air-shopping-api";
import { createAction, createSlice } from "@reduxjs/toolkit";

export interface ShopInitialState {
  [prop: string]: unknown;
}

const SLICE_NAME = "exchange/shop";

const initialState: ShopInitialState = {};

const shopSlice = createSlice({
  initialState,
  name: SLICE_NAME,
  reducers: {},
});

export const getTripDetails = createAction<string>(
  `${SLICE_NAME}/getFlightDetails`
);

export const getFlightSummaries = createAction(
  `${SLICE_NAME}/getFlightSummaries`,
  (bookingId: string, isMobile = false) => ({
    payload: {
      bookingId,
      isMobile,
    },
  })
);

export const submitExchangeReq = createAction(
  `${SLICE_NAME}/submitExchangeReq`,
  (totalPrice: FiatPrice) => ({
    payload: `${totalPrice.currencyCode}${totalPrice.value.toFixed(2)}`,
  })
);

export { initialState as shopInitialState };
export default shopSlice.reducer;
